import React, { useState } from "react";
import MessageHelper from "../../../../entities/message/message-helper";
import ThreadHelper from "../../../../entities/thread/thread-helper";
import { EventEmitter } from "../../../../shared/utils/event-emitter";
import Events from "../../../../const/events";
import { useSelector } from "react-redux";
import "./message-composer.css";

const MessageComposer = ({ onSendMessage = () => {}, canSend = true, selectedThread }) => {
  const [message, setMessage] = useState(""); // State to track the message being typed
  const [isSending, setIsSending] = useState(false); // State to track if message is being sent

  const templates = useSelector(
    (state) => state?.templateStore?.templates || []
  );

  // Handle input change
  const handleInputChange = (e) => {
    setMessage(e.target.value);
  };

  // Function to send message
  const handleSendMessage = async () => {
    if (message.trim() === "" || isSending) return; // Do not send empty messages
    if (!canSend) {
      EventEmitter.dispatch(Events.SHOW_TWILIO_SANDBOX_WARNING);
      return;
    }
    setIsSending(true); // Disable input while sending message
    try {
      await ThreadHelper.sendMessage({ messageText: message }); // Send message
      onSendMessage();
      setMessage(""); // Clear input after message is sent
    } catch (error) {
      console.error("Error sending message:", error);
    }
    setIsSending(false); // Re-enable input after message is sent
  };

  // Handle Enter key to send message
  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !isSending) {
      e.preventDefault(); // Prevent newline insertion
      handleSendMessage();
    }
  };

  const _sendTemplate = (template) => {
    console.log('template :>> ', template);
    MessageHelper.sendTemplateMessage(template, selectedThread);
    // hide
    setModalShow(false);
  };

  const [inputActive, setInputActive] = useState(false);
  const [modalShow, setModalShow] = useState(false);

  return (
    <div className={"chat-footer " + (inputActive ? "active" : "")}>
      <div className="typing-area">
        <span className="chat-admin">
          <img
            src="assets/images/profile-avatar.png"
            alt="user"
            className="rounded-circle thumb-sm"
          />
        </span>
        <input
          type="text"
          className="form-control"
          placeholder="Type something here..."
          value={message}
          onClick={(e) => setInputActive(true)}
          onBlur={(e) => setInputActive(false)}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress} // Handle Enter key press
          disabled={isSending} // Disable input while sending
          style={isSending ? { opacity: 0.5 } : {}} // Reduce opacity while sending
        />
      </div>

      <div className="actions-area">
        <div
          className="icon-button"
          title="Select template"
          onClick={(e) => setModalShow(true)}
        >
          <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M11.1206 1.02129C12.109 1.0067 12.9592 1.54344 13.7096 2.29199L13.7104 2.29285L14.9707 3.5531C15.1118 3.34249 15.2753 3.14257 15.461 2.95679C17.0025 1.4153 19.5018 1.4153 21.0433 2.9568C22.5848 4.49829 22.5848 6.99754 21.0433 8.53904C20.8575 8.72481 20.6576 8.88828 20.447 9.02939L21.7072 10.2896L21.708 10.2905C22.4565 11.0408 22.9932 11.891 22.9787 12.8794C22.9642 13.8602 22.41 14.6797 21.7058 15.3789C21.7054 15.3793 21.7049 15.3798 21.7045 15.3802L20.4287 16.656C19.9519 17.1327 19.3279 17.0824 18.9512 16.9234C18.5783 16.7659 18.1803 16.4041 18.0897 15.8508C18.0262 15.4628 17.8456 15.0914 17.5452 14.791C16.7847 14.0306 15.5518 14.0306 14.7914 14.791C14.0309 15.5515 14.0309 16.7844 14.7914 17.5448C15.0917 17.8452 15.4631 18.0259 15.8511 18.0894C16.4044 18.18 16.7663 18.5779 16.9237 18.9509C17.0827 19.3276 17.1331 19.9516 16.6564 20.4283L15.377 21.7077C15.3766 21.7081 15.3762 21.7085 15.3757 21.709C14.6777 22.412 13.8591 22.965 12.8794 22.9795C11.8922 22.994 11.0429 22.4585 10.2938 21.7112L10.2929 21.7103L9.0295 20.4469C8.88841 20.6575 8.72496 20.8573 8.53922 21.0431C6.99773 22.5846 4.49847 22.5846 2.95698 21.0431C1.41549 19.5016 1.41549 17.0023 2.95698 15.4608C3.14272 15.2751 3.3426 15.1116 3.55317 14.9706L2.29294 13.7103L2.29208 13.7095C1.54353 12.9591 1.00681 12.1089 1.02141 11.1205C1.03589 10.1397 1.59009 9.32029 2.29424 8.62107C2.29469 8.62062 2.29515 8.62017 2.2956 8.61972L3.57165 7.34366C4.0484 6.86691 4.67249 6.9173 5.04916 7.07633C5.4221 7.23378 5.82003 7.59563 5.91062 8.14898C5.97414 8.53701 6.15479 8.90842 6.45519 9.20882C7.21563 9.96926 8.44856 9.96926 9.209 9.20882C9.96945 8.44837 9.96945 7.21545 9.20901 6.455C8.90861 6.1546 8.53719 5.97396 8.14917 5.91043C7.59581 5.81984 7.23397 5.42191 7.07652 5.04897C6.91749 4.6723 6.86709 4.04821 7.34384 3.57146L8.61978 2.29553C8.62025 2.29506 8.62071 2.29459 8.62118 2.29413C9.32039 1.58996 10.1398 1.03576 11.1206 1.02129ZM11.1501 3.02107C10.9456 3.02409 10.6003 3.13919 10.0393 3.70438L10.0367 3.70706L9.49334 4.25039C9.90279 4.44025 10.2863 4.70387 10.6232 5.04079C12.1647 6.58228 12.1647 9.08154 10.6232 10.623C9.08173 12.1645 6.58247 12.1645 5.04098 10.623C4.70406 10.2861 4.44044 9.9026 4.25058 9.49315L3.70715 10.0366L3.70449 10.0392C3.13933 10.6002 3.02421 10.9455 3.02119 11.1501C3.01827 11.3476 3.11651 11.7039 3.70773 12.2967C3.70782 12.2968 3.70792 12.2969 3.70801 12.297L6.03813 14.6271C6.30605 14.895 6.39954 15.2913 6.2796 15.6508C6.15966 16.0102 5.8469 16.2709 5.47177 16.3243C5.06894 16.3815 4.68196 16.5643 4.37119 16.8751C3.61075 17.6355 3.61075 18.8684 4.3712 19.6289C5.13164 20.3893 6.36456 20.3893 7.12501 19.6289C7.43577 19.3181 7.61854 18.9311 7.67581 18.5283C7.72914 18.1532 7.9899 17.8404 8.34931 17.7205C8.70872 17.6005 9.10505 17.694 9.37296 17.9619L11.7063 20.2953C11.7066 20.2955 11.7068 20.2958 11.7071 20.296C11.7071 20.2961 11.7071 20.2961 11.7072 20.2961C12.2975 20.8848 12.6529 20.9826 12.8499 20.9797C13.0539 20.9767 13.3986 20.8619 13.9575 20.2988L13.9601 20.2961L14.5069 19.7494C14.0975 19.5595 13.714 19.2959 13.3772 18.9591C11.8357 17.4176 11.8357 14.9183 13.3772 13.3768C14.9186 11.8353 17.4179 11.8353 18.9594 13.3768C19.2963 13.7137 19.5599 14.0972 19.7497 14.5065L20.2929 13.9633L20.2956 13.9607C20.8608 13.3998 20.9759 13.0544 20.9789 12.8499C20.9818 12.6524 20.8836 12.2961 20.2928 11.7036C20.2925 11.7034 20.2923 11.7031 20.2921 11.7029L17.9619 9.3728C17.694 9.10487 17.6005 8.70853 17.7205 8.34912C17.8404 7.9897 18.1532 7.72895 18.5284 7.67564C18.9312 7.61839 19.3183 7.43561 19.6291 7.12482C20.3895 6.36438 20.3895 5.13145 19.6291 4.37101C18.8686 3.61056 17.6357 3.61056 16.8752 4.37101C16.5644 4.6818 16.3817 5.06882 16.3244 5.4717C16.2711 5.84683 16.0104 6.15962 15.6509 6.27957C15.2915 6.39953 14.8952 6.30604 14.6273 6.03812L12.2971 3.70792C12.2969 3.70779 12.2968 3.70767 12.2967 3.70754C11.704 3.11638 11.3476 3.01815 11.1501 3.02107Z" fill="#000000"></path> </g></svg>
        </div>

        <div className="chat-fatures">
          {message.trim() !== "" && ( // Conditionally show the send button
            <a href="#" onClick={handleSendMessage} title="Send message" className="bouncy-button small">
              <i className="fas fa-paper-plane"></i>
            </a>
          )}
        </div>
      </div>

      <div className={"whatsapp-preview-modal " + (modalShow ? "show" : "")}>
        <div className="overlay" onClick={(e) => setModalShow(false)}></div>

        <div className="modal-container">
          <div className="modal-header">
            <h6>Send Template Invitation</h6>
            <span className="close-btn" onClick={(e) => setModalShow(false)}>×</span>
          </div>

          <div className="modal-body">
            <div className="context-message">
              <div className="info-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20">
                  <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                </svg>
              </div>
              <p>You can only send invitation for now as the user was not active in the platform recently</p>
            </div>
            <div className="preview-container">
              <div className="preview-header">
                <div className="phone-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                    <path fill="currentColor" d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm0 1.75c-5.1 0-9.25 4.15-9.25 9.25s4.15 9.25 9.25 9.25 9.25-4.15 9.25-9.25S17.1 2.75 12 2.75z"/>
                    <path fill="currentColor" d="M12 7a2 2 0 012 2v6a2 2 0 01-2 2H8a2 2 0 01-2-2V9a2 2 0 012-2h4zm0 1.5H8a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h4a.5.5 0 00.5-.5V9a.5.5 0 00-.5-.5z"/>
                  </svg>
                </div>
                <span>Your phone number</span>
              </div>

              {templates
                ?.filter(template => template.friendlyName === "relai_onboard")
                ?.map((template, index) => (
                  <div key={index} className="preview-content">
                    <div className="message-bubble">
                      <p>{template?.types["twilio/quick-reply"]?.body}</p>
                      <div className="quick-reply-options">
                        <button className="quick-reply-btn">
                          {template?.types["twilio/quick-reply"]?.actions?.[0]?.title || "Yes"}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn-cancel" onClick={(e) => setModalShow(false)}>
              Cancel
            </button>
            <button 
              className="btn-send"
              onClick={() => {
                const template = templates?.find(t => t.friendlyName === "relai_onboard");
                if (template) {
                  _sendTemplate(template);
                }
                setModalShow(false);
              }}
            >
              Send Invite
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageComposer;
